/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import NavLink from './NavLink'
import styled from '@emotion/styled'


const StyledNavLink = styled(NavLink)`
  display: table-cell;
  color: ${({ theme }) => theme.secondary.base};
  font-family: ${({ theme }) => theme.fonts.light};
  font-size: 13px;
  padding: 8px;

  &.active {
    color: ${({ theme }) => theme.secondary.base};
    background: ${({ theme }) => theme.secondary.light};
  }
`

const spanStyle = { display: 'block' }

const AppNavLink = ({ children, Icon, to }) => (
  <StyledNavLink to={to}>
    <Icon size={28} />
    <span style={spanStyle}>{children}</span>
  </StyledNavLink>
)

AppNavLink.propTypes = {
  children: PropTypes.any,
  Icon: PropTypes.func.isRequired,
  to: PropTypes.string.isRequired,
}

export default AppNavLink
